import { PoliciesClient } from '~domain/api-clients/policies-client';
import { yousetApiUrlRegistry } from '~domain/configs/url-registry/url-registry';
import { loadServerClient } from '~frontend-common/client/client-loader';
import { logoutResponseTransform } from './logout-response-transform';

export const policiesClient = loadServerClient(PoliciesClient, yousetApiUrlRegistry.urls.policies);

policiesClient.api.addResponseTransform(logoutResponseTransform);
